import React from 'react';
import PropTypes from 'prop-types';
import InclusiveLeadTimeType from '../../lead-times/inclusiveLeadTimeType';
import BuildToOrderLeadTimeLabel from '../../quotes/lead-times/BuildToOrderLeadTimeLabel';
import StockRunLeadTimeLabel from '../../quotes/lead-times/StockRunLeadTimeLabel';

const InclusiveMosaicLeadTime = ({ leadTime }) => {
  if (!leadTime) {
    return null;
  }
  const isBuildToOrder =
    InclusiveLeadTimeType[leadTime.type] === InclusiveLeadTimeType.BuildToOrder;
  return (
    <div className="row lowest-lead-time">
      <div className="col-6 lead-time-type">
        {InclusiveLeadTimeType[leadTime.type]}
      </div>
      <div className="col-6 lead-time-value">
        {leadTime.imageUrl && leadTime.value && (
          <img
            src={leadTime.imageUrl}
            className="img-fluid"
            alt={`Lead time of ${leadTime.value} days`}
          />
        )}
        {leadTime.stockRunLeadTime && (
          <StockRunLeadTimeLabel
            minimumNumberOfDays={leadTime.stockRunLeadTime.minimumNumberOfDays}
            availableOn={leadTime.stockRunLeadTime.availableOn}
          />
        )}
        {!leadTime.stockRunLeadTime && (
          <div className={!isBuildToOrder ? 'from-inventory' : ''}>
            <BuildToOrderLeadTimeLabel leadTimeDays={leadTime.value} />
          </div>
        )}
      </div>
    </div>
  );
};

InclusiveMosaicLeadTime.propTypes = {
  leadTime: PropTypes.shape({
    type: PropTypes.string.isRequired,
    value: PropTypes.number,
    imageUrl: PropTypes.string,
    stockRunLeadTime: PropTypes.shape({
      availableOn: PropTypes.string.isRequired,
      minimumNumberOfDays: PropTypes.number.isRequired,
    }),
  }),
};

export default InclusiveMosaicLeadTime;
